import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import {
  Container,
  Typography,
  Grid,
  Card,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  styled,
  createTheme,
  ThemeProvider,
  Box,
  CardMedia,
  Button,
} from '@mui/material';
import moment from 'moment';
import DownloadIcon from '@mui/icons-material/Download';


const statistiquesCommerceData = [
  {
    ministere: 'Ministère du Commerce, du Transport, de l’Industrie et du Tourisme',
    annuaires: 'ANNUAIRE STATISTIQUE ÉDITION 2021',
    description: 'Un aperçu des performances du secteur économique, ce rapport inclut des données sur le commerce, les transports et le tourisme, détaillant les tendances et les impacts sur l’économie nationale en 2021.',
    date: "2021-12-31",
    link: "/documents/Sectorials/annuaire-du-MCTIT-edition-2021.f-6.pdf"
  },
  {
    ministere: 'Ministère du Commerce, du Transport, de l’Industrie et du Tourisme',
    annuaires: 'ANNUAIRE STATISTIQUE ÉDITION 2019',
    description: 'Un aperçu des performances du secteur économique, ce rapport inclut des données sur le commerce, les transports et le tourisme, détaillant les tendances et les impacts sur l’économie nationale en 2019.',
    date: "2019-12-31",
    link: "/documents/Sectorials/Annuaire-statistique-2019.pdf"
  },
 
];

function MinistereCommerce() {
  const [visibleCount, setVisibleCount] = useState(2); 
  const [selectedYear, setSelectedYear] = useState('Tous');
  const [filteredStatistiques, setFilteredStatistiques] = useState(statistiquesCommerceData);

  const handleShowMore = () => {
    setVisibleCount((prevCount) => Math.min(prevCount + 2, statistiquesCommerceData.length)); 
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);
    if (year === 'Tous') {
      setFilteredStatistiques(statistiquesCommerceData);
    } else {
      const filtered = statistiquesCommerceData.filter((statistique) => {
        const statistiqueYear = new Date(statistique.date).getFullYear();
        return statistiqueYear === parseInt(year);
      });
      setFilteredStatistiques(filtered);
    }
  };

  const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.dark,
    },
  }));

  const theme = createTheme({
    palette: {
      primary: {
        main: '#388E3C',
      },
      background: {
        default: '#f5f5f5',
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      body1: {
        fontSize: 16,
        letterSpacing: 0.5,
        color: '#6B778C',
      },
      h4: {
        fontWeight: '600',
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: theme.palette.background.default, paddingBottom: '32px' }}>
        <NavigationBar />
        <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main, marginBottom: '16px' }}>
            Ministère du Commerce, du Transport, de l’Industrie et du Tourisme
          </Typography>
          <Divider style={{ margin: '16px 0' }} />
          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px' }}>
            Le Ministère du Commerce, du Transport, de l’Industrie et du Tourisme joue un rôle crucial dans le développement économique national. Cette page fournit un aperçu des statistiques importantes concernant les secteurs du commerce, des transports, de l’industrie et du tourisme.
          </Typography>

        
          <FormControl fullWidth variant="outlined" style={{ marginLeft: '0px', width: '300px' }}>
            <InputLabel id="year-select-label">Filtrer par année de réalisation</InputLabel>
            <StyledSelect
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              onChange={handleYearChange}
              label="Filtrer par année de réalisation"
            >
              <MenuItem value="Tous">Tous</MenuItem>
              {[...new Set(statistiquesCommerceData.map((statistique) => new Date(statistique.date).getFullYear()))]
                .sort()
                .map((year) => (
                  <MenuItem key={year} value={year.toString()}>
                    {year}
                  </MenuItem>
                ))}
            </StyledSelect>
          </FormControl>

     
          <Grid container spacing={1} style={{ marginTop: '20px' }}>
            {filteredStatistiques.slice(0, visibleCount).map((statistique, index) => (
              <Grid item xs={12} sm={12} key={index}>
                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden' }}>
                  <Box sx={{ display: 'flex' }}>
                    <a
                      href={statistique.link}
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <CardMedia
                        component="img"
                        sx={{ width: 71, height: 100, m: 2 }}
                        image={"assets/annuaires/minicom.png"} 
                        alt={statistique.annuaires}
                      />
                    </a>
                    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                      <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: theme.palette.primary.main }}>
                        <a
                          href={statistique.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                          {<DownloadIcon />}{statistique.annuaires}
                        </a>
                      </Typography>
                      <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                        {statistique.description}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        Publié en {moment(statistique.date).format('MMMM YYYY')}
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>

    
          {visibleCount < filteredStatistiques.length && (
            <Button
              onClick={handleShowMore}
              style={{
                marginTop: '20px',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              }}
            >
              Plus de Statistiques
            </Button>
          )}
        </Container>
        <br />
        <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default MinistereCommerce;